import React from "react";
import MyRequests from "../../../components/common/MyRequests";
export default function Page() { return <MyRequests role="Comum" />; }
